import { Product } from '../product/Product'
import { Prop } from '@typegoose/typegoose'
import { Field, ID, Float, ObjectType, InputType } from 'type-graphql'
import { RelatedEntity } from '../base/RelatedEntity'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('LogisticItemInput')
export class LogisticItem {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('lgi') })
  _id: string

  @Field(() => Product)
  @Prop({ type: () => RelatedEntity })
  product: ReturnType<() => Product>

  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => Float)
  @Prop({ type: Number })
  inventoryCount: number
}
